import React, { FC } from 'react'
import { Box, theme } from '@gassan-ui'
import { Heading, Text } from '@rolex-ui'
import LocalizedLink from '@components/Localization/LocalizedLink'
import CtaButtons from '../RetailerCtaButtons'
import { RolexStore } from '@lib/kontent/models/RolexStore'
import { rem } from 'polished'

type Props = {
  retailer: RolexStore
}

const Retailer: FC<Props> = ({ retailer }) => {
  return (
    <Box
      p="2rem"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      bg="shades.200"
    >
      <LocalizedLink as={`/rolex/contact/${retailer.url_slug.value}`} href="/rolex/contact/[sid]">
        <Box as="a">
          <Heading variant="smallSubtitle" color={theme.rolex.colors.primary}>
            Rolex official retailer
          </Heading>
          <Heading variant="gridTitle">{retailer.name.value}</Heading>

          <Text variant="smallDescription" mb={rem(20)}>
            {retailer.address_details.value}
          </Text>
        </Box>
      </LocalizedLink>
      <CtaButtons
        phoneNumber={retailer.phone_number.value}
        directionsUrl={`https://maps.google.com?saddr=Current+Location&daddr=${retailer.latitude.value},${retailer.longitude.value}`}
        detailSlug={retailer.url_slug.value}
      />
    </Box>
  )
}

export default Retailer
